import { Box, Form } from "dash-ui";
import { FunctionComponent, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import JoditEditor from "jodit-react";
import { joditConfig } from "v2/constants/constants";
import { cleanEmptyHtml } from "common/helpers/joditHelpers";

type SalesGalleryAddressProps = {
  value: string;
  onChange: (value: string) => void;
};

const SalesGalleryAddress: FunctionComponent<SalesGalleryAddressProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation("forms");
  const addressEditor = useRef(null);

  const config: any = useMemo(
    () => ({
      ...joditConfig,
      placeholder:
        t("placeholders.salesGalleryAddress") ||
        "Enter the sales gallery address and location details",
      limitChars: 2000,
      height: 200,
    }),
    [t]
  );

  return useMemo(
    () => (
      <Box mx={6} mt={4}>
        <Form.Group w="100%">
          <Form.Label>{t("labels.salesGalleryAddress")}</Form.Label>
          <Box mt={2}>
            <JoditEditor
              ref={addressEditor}
              value={value || ""}
              key="sales-gallery-address-editor"
              onChange={(value) => {
                const cleanedValue = cleanEmptyHtml(value);
                onChange(cleanedValue);
              }}
              config={config}
            />
          </Box>
        </Form.Group>
      </Box>
    ),
    [value, onChange, config, t]
  );
};

export default SalesGalleryAddress;
